import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/DraftVersionsPage.css"; // ✅ FIXED PATH

const DraftVersionsPage = () => {
  const navigate = useNavigate();

  const [versions, setVersions] = useState([
    {
      version: "v1",
      createdAt: "9/1/2026 10:00",
      status: "success",
      file: "PDC101_v1.docx",
      isLatest: false,
    },
    {
      version: "v2",
      createdAt: "10/1/2026 12:30",
      status: "failed",
      file: "PDC101_v2.docx",
      isLatest: false,
    },
    {
      version: "v3",
      createdAt: "11/1/2026 09:00",
      status: "success",
      file: "PDC101_v3.docx",
      isLatest: true,
    },
  ]);

  /* 📥 DOWNLOAD DOCX */
  const downloadDoc = (fileName) => {
    const content = `
Patent Draft Document
---------------------
File: ${fileName}
Generated by Kognitycs Draft Engine
    `;

    const blob = new Blob([content], {
      type:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  };

  /* 🔁 RETRY FAILED VERSION */
  const retryFailedVersion = (version) => {
    setVersions((prev) =>
      prev.map((v) =>
        v.version === version
          ? {
              ...v,
              status: "success",
              file: `PDC101_${version}_retry.docx`,
            }
          : v
      )
    );
  };

  return (
    <div className="versions-container">
      <h2>Draft Versions</h2>
      <p className="subtitle">Manage, download and retry draft versions</p>

      <table className="versions-table">
        <thead>
          <tr>
            <th>Version</th>
            <th>Created At</th>
            <th>Status</th>
            <th>File</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {versions.map((v) => (
            <tr key={v.version}>
              <td>
                {v.version}
                {v.isLatest && <span className="latest-badge">Latest</span>}
              </td>

              <td>{v.createdAt}</td>

              <td>
                <span className={`status ${v.status}`}>
                  {v.status}
                </span>
              </td>

              <td>{v.file}</td>

              <td className="actions">
                <button
                  className="link-btn"
                  onClick={() => downloadDoc(v.file)}
                >
                  Download
                </button>

                {v.status === "failed" && (
                  <button
                    className="retry-btn"
                    onClick={() => retryFailedVersion(v.version)}
                  >
                    Retry
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="version-actions">
        <button className="secondary-btn" onClick={() => navigate("/admin")}>
          Back to Drafts
        </button>
      </div>
    </div>
  );
};

export default DraftVersionsPage;
